export default __webpack_public_path__ + "static/media/hackathon.4befedbe.png";